import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { BranchStoreService } from '../../branch-store.service';
import {
  BRANCH_STORE_TTL_ES,
  IBranchStore,
  IBranchStoreTable
} from '../../branch-store.interface';

@Component({
  selector: 'pg-branch-store-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class BranchStoreSelectComponent extends SelectTemplate {
  constructor(private branchStoreService: BranchStoreService) {
    super(BRANCH_STORE_TTL_ES, branchStoreService);
  }

  ngOnInit() {
    this.table.settings = {
      title: BRANCH_STORE_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'name' },
        { header: 'Dirección', field: 'address' },
        { header: 'Departamento', field: 'department' },
        { header: 'Provincia', field: 'province' },
        { header: 'Distrito', field: 'district' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.branchStoreService
      .getData$()
      .subscribe((data: IBranchStore[]) => {
        this.parseToTable(data);
      });
  }

  parseToTable(dataService: IBranchStore[]) {
    const dataTable: IBranchStoreTable[] = dataService.map((item) => {
      const { departmentId, provinceId, districtId } = item;
      return {
        ...item,
        department: this.branchStoreService.getNameDepartament(departmentId),
        province: this.branchStoreService.getNameProvince(
          departmentId,
          provinceId
        ),
        district: this.branchStoreService.getNameDistrict(
          provinceId,
          districtId
        )
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
